import { observable } from 'mobx';

export type ConnectedCalendarResponseArgs = {
  id: number;
  user_id: number;
  provider: string;
  is_default: boolean;
  email: string;
};

export type ConnectedCalendarArgs = {
  id: number;
  userId: number;
  provider: string;
  isDefault: boolean;
  email: string;
};

export const convertConnectedCalendarResponseToArgs = (response: ConnectedCalendarResponseArgs) => {
  const args: ConnectedCalendarArgs = {
    id: response.id,
    userId: response.user_id,
    provider: response.provider,
    isDefault: response.is_default,
    email: response.email
  };
  return args;
};

export default class ConnectedCalendar {
  @observable id: number;

  @observable userId: number;

  @observable provider: string;

  @observable isDefault: boolean;

  @observable email: string;

  constructor(args: ConnectedCalendarArgs) {
    this.id = args.id;
    this.userId = args.userId;
    this.provider = args.provider;
    this.isDefault = args.isDefault;
    this.email = args.email;
  }
}
